module.exports = __webpack_public_path__ + "static/xeneco-logo-2-1609a6a1475126a5778a73891a0f9a2a.png";